// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indicator-style-icon[data-v-5a47f012] {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 63px;
  height: 63px;
  border-radius: 50%;
}
.indicator-style-icon i[data-v-5a47f012] {
  font-size: 33px;
}
`, "",{"version":3,"sources":["webpack://./src/components/charts/indicatorStyle/styleIcon.vue","webpack://./styleIcon.vue"],"names":[],"mappings":"AAoDA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;ACnDF;AD4CA;EAUI,eAAA;ACnDJ","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.indicator-style-icon {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 63px;\n  height: 63px;\n  border-radius: 50%;\n\n  i {\n    font-size: 33px;\n  }\n}\n",".indicator-style-icon {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 63px;\n  height: 63px;\n  border-radius: 50%;\n}\n.indicator-style-icon i {\n  font-size: 33px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
